import { Box, CircularProgress } from '@mui/material'
import { useGlobalState } from 'contexts/GlobalStateContext'
import useAuth from 'hooks/useAuth'
import RewardsDashboard from 'pages/Admin/Rewards/RewardsDashboard'
import React from 'react'
import { Navigate } from 'react-router-dom'

const MyRewards: React.FC = () => {
  const { profile, isLoading } = useAuth()
  const { checkSubscriptionTierFeature } = useGlobalState()

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
        <CircularProgress />
      </Box>
    )
  }

  if (!profile?.user?.id) {
    return null
  }

  // If org doesn't have REWARDS feature, redirect to variable compensation dashboard
  if (!checkSubscriptionTierFeature('REWARDS.ALL')) {
    return <Navigate to="/dashboard" replace />
  }

  // Render the rewards dashboard with the current user's ID
  return <RewardsDashboard userId={profile.user.id} />
}

export default MyRewards
